import React from 'react';
import logo from '../../../assets/images/besi_logo.png';
class Footer extends React.Component {

    
  render() {

    let textToDisplay = "You are not allowed to use this APP. Please contact your system admin!";

    const currentDate = new Date();
    const startDate = new Date('2025-05-27');
    const endDate = new Date('2025-06-29');

    if ((currentDate >= startDate && currentDate <= endDate)) {
      textToDisplay = "We are checking this app, please be patient!";
    }
    
    return (
        <div className="body-inner d-flex justify-content-center align-items-center">
        <div className="card card-white w-25">
          <div className="card-content text-center">
          <img className="mb-4"src={logo} alt="BESI" />
            
            <form>
              <fieldset>
                <div className="form-group">
                  <div className="additional-info text-center text-small">
                  {textToDisplay} 
                 </div>
                </div>
              </fieldset>
            </form>
          </div>

        </div>
      </div>
    );
  }
}

export default Footer;
